module.exports = __webpack_public_path__ + "static/media/logo-rus.28294174.svg";